/* ===== Поля и информация для полей ===== */

const baseForms = [
    {
        name: "name",
        type: "text",
        placeholder: "Иванов Иван Иванович",
        required: true,
    },
    {
        name: "phone",
        type: "tel",
        placeholder: "+7 (999) 888-77-66",
        inputMode: "numeric",
        required: true,
    },
    {
        name: "email",
        type: "email",
        placeholder: "ivanov@mail.ru",
        required: false,
    },
]

export default baseForms;